export default "__VITE_ASSET__aa621bb9__"